// tiktokPrivacy — labels for TikTok's `privacy_level_options` values.
//
// 🔴 LINT ALLOWLIST FILE (decision D-006). See pl/tiktokPrivacy.ts for the full
// reasoning: "Followers" is a banned word everywhere else, because the ban exists
// to stop us promising an audience. Here it is the platform's own name for a
// visibility setting, which SPEC A7 requires us to display verbatim. The
// allowlist covers ONLY this file and ONLY the FOLLOWER_OF_CREATOR key.
//
// The options themselves come from `creator_info` at runtime — never treat this
// list as the set of choices an account actually has.
export const tiktokPrivacy = {
  PUBLIC_TO_EVERYONE: 'Everyone',
  MUTUAL_FOLLOW_FRIENDS: 'Friends',
  FOLLOWER_OF_CREATOR: 'Followers',
  SELF_ONLY: 'Only me',
} as const
